// ----------------------------------------------------------------------

export default function useApiUrl() {
  let baseUrl = '';
  if (process.env.NODE_ENV !== 'production') {
    baseUrl = 'http://localhost:60158/';
  } else {
    baseUrl = 'https://api.manouna.be/';
  }

  console.log(`baseurl: ${baseUrl}`);

  const manounaApiUrl = `${baseUrl}api/manouna/`;
  const appApiUrl = `${baseUrl}api/app/`;

  return { manounaApiUrl, appApiUrl };
}
